import { Reducer } from "redux";

import { GetDisciplineLevelNote } from "../models/Api/Notes";
import { GetAuthDisciplineLevelNotesDispatchTypes } from "../models/DispatchTypes/Notes";
import { GetAuthDisciplineLevelNotesActionDispatchTypes } from "../constants/Notes";

export const initialState: GetDisciplineLevelNote = {
  loading: false,
  response: {
    disciplineNoteId: -1,
    serviceRequestDisciplineId: -1,
    noteEntryId: -1,
    dateCreated: "",
    dateUpdated: "",
    userCreated: "",
    fullNameCreated: "",
    noteTemplateId: -1,
    templateName: "",
    noteEntryJson: "",
    comment: "",
    highestCred: null,
  },
};

const GetAuthDisciplineLevelNotesReducer: Reducer<
  GetDisciplineLevelNote,
  GetAuthDisciplineLevelNotesDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetAuthDisciplineLevelNotesActionDispatchTypes.GET_AUTH_DISCIPLINE_LEVEL_NOTES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetAuthDisciplineLevelNotesActionDispatchTypes.GET_AUTH_DISCIPLINE_LEVEL_NOTES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetAuthDisciplineLevelNotesActionDispatchTypes.GET_AUTH_DISCIPLINE_LEVEL_NOTES_RESET: {
      return initialState;
    }
  }
  return state;
};

export default GetAuthDisciplineLevelNotesReducer;
